import { isBefore, isValid, parseISO } from "date-fns"

export const mode = "PROD" // DEV/PROD
export const apiUrl =
  mode === "DEV" ? "https://example.com" : "https://example.com"

export const googleAPIKeys =
  mode === "DEV"
    ? "AIzaSyDvdPkHC76DfEQLtDwugNOI3vaFt-k0r-g"
    : "AIzaSyDvdPkHC76DfEQLtDwugNOI3vaFt-k0r-g"

/**
 * Must be a stable module-level constant and identical everywhere we call
 * useLoadScript — different `libraries` arrays cause Maps to load twice.
 */
export const GOOGLE_MAPS_LIBRARIES = ["geometry"]

export const defaultLat = 23.8859
export const defaultLng = 45.0792

export const hasStarted = startsAt => {
  if (!startsAt) return false // Handle missing value

  const startDate = parseISO(startsAt)
  if (!isValid(startDate)) return false // Handle invalid date

  return isBefore(startDate, new Date()) // Check if it has started
}

export const hasExpired = endsAt => {
  if (!endsAt) return false // Handle missing value

  const endDate = parseISO(endsAt)
  if (!isValid(endDate)) return false // Handle invalid date

  return isBefore(endDate, new Date()) // Check if it has expired
}

export const aggregateAndSortTopCategories = categories => {
  const aggregated = {}

  for (const category of categories) {
    const id = category?._id

    if (!aggregated[id]) {
      aggregated[id] = { ...category }
    } else {
      aggregated[id].purchasedCount += category?.purchasedCount
    }
  }

  const result = Object.values(aggregated)?.sort(
    (a, b) => b?.purchasedCount - a?.purchasedCount
  )

  return result
}

export const formatWithCommas = value => {
  const num = Number(value)
  if (isNaN(num)) return value

  return num >= 1000
    ? num.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 8,
      })
    : num.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 8,
      })
}

// Browser-compatible HMAC SHA256 function using Web Crypto API
export function createHmacSha256(secretKey, data) {
  try {
    const encoder = new TextEncoder()
    const keyData = encoder.encode(secretKey)
    const messageData = encoder.encode(data)

    return crypto.subtle
      .importKey("raw", keyData, { name: "HMAC", hash: "SHA-256" }, false, [
        "sign",
      ])
      .then(function (cryptoKey) {
        return crypto.subtle.sign("HMAC", cryptoKey, messageData)
      })
      .then(function (signature) {
        const hashArray = Array.from(new Uint8Array(signature))
        const hashHex = hashArray
          .map(function (b) {
            return b.toString(16).padStart(2, "0")
          })
          .join("")
        return hashHex
      })
      .catch(function (err) {
        console.error("Error creating HMAC:", err)
        return null
      })
  } catch (err) {
    console.error("Error creating HMAC:", err)
    return Promise.resolve(null)
  }
}

export function generateStrongKey() {
  const array = new Uint8Array(32)
  window.crypto.getRandomValues(array) // 32 secure random bytes

  // Convert bytes → Base64
  const binary = String.fromCharCode(...array)
  return btoa(binary)
}
